module.exports = require("babel-runtime/helpers/createClass");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/createClass"
// module id = 2
// module chunks = 0